import Vue from 'vue';
import VueRouter from 'vue-router';
import Survey from '../views/Survey';

Vue.use(VueRouter)

const routes = [
  {
    path: '/id/:tabletId',
    name: 'tablet.id',
    component: Survey,
    props: true,
  },

  {
    path: '/:tabletLink',
    name: 'tablet.link',
    component: Survey,
    props: true,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
